import React, { useState } from "react";

import TwoFactorAuthentication from "./TwoFactorAuthentication";

import { Tab, Tabs, Box, useMediaQuery } from "@mui/material"
import { FormattedMessage, useIntl } from "react-intl";
import lodash from "lodash";
import PasswordPanel from "./PasswordPanel";

const SecurityTab = ({ accountSettings, setAccountSettings }) => {

  const isMdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const intl = useIntl();

  const {
    enabledMFATypes,
    email
  } = accountSettings || {};

  const handle2FaUpdates = (newValues) => {

    var temp = lodash.cloneDeep(accountSettings);
    temp.enabledMFATypes = newValues;
    setAccountSettings(temp);

  }

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }

  return (<Box
    sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224, flexDirection: isMdDown ? "column" : "row", }}
  >

    <Tabs
      orientation={isMdDown ? "horizontal" : "vertical"}
      value={tabValue}
      onChange={handleTabChange}
      aria-label="security tabs"
      fullWidth={isMdDown}
      sx={{ borderRight: 1, borderColor: 'divider', marginRight: 2, alignItems: "end", }}
    >
      <Tab label={intl.formatMessage({ id: "users.security.password" })} />
      <Tab label={intl.formatMessage({ id: "users.security.twofactorauth" })} />

    </Tabs>
    {tabValue === 0 && (<Box><PasswordPanel /></Box>)}
    {tabValue === 1 && (<Box>
      <TwoFactorAuthentication enabledMFATypes={enabledMFATypes} username={email} onUpdateMFASettings={handle2FaUpdates} />
    </Box>)}

  </Box>);
}

export default SecurityTab;